import { IShoppingCartProduct } from '@monofront/types';
import groupCartProductsByType, {
  ISortProductByType,
} from '../../utils/groupCartProductsByProductType';
import { useMemo } from 'react';

export const useGroupCartProductsByType = (
  shoppingCartProducts: IShoppingCartProduct[],
  fallbackLabel: string,
): ISortProductByType[] => {
  return useMemo(
    () => groupCartProductsByType(shoppingCartProducts || [], fallbackLabel),
    [shoppingCartProducts, fallbackLabel],
  );
};
